import { clearSignedInBrowserState } from './clearSignedInBrowserState';

/**
 * Ends the session in this browser: clears the signed-in browser state, then reloads the current page
 * once, so it loads as a guest. Firestore cannot be used again in this page once terminated.
 */
export const forceSignOut = async () => {
  await clearSignedInBrowserState();
  if (typeof window !== 'undefined') {
    window.location.reload();
  }
};
